
export {ClayPaginationBarWithBasicItems,
PaginationBar,
DropDown,
Results} from '../../frontend-js-clay-web/__liferay__/exports/@clayui$pagination-bar.js';
import __x__ from '../../frontend-js-clay-web/__liferay__/exports/@clayui$pagination-bar.js';export default __x__;